import { request } from "../helper/axios_helper";

export const getAllSuiteData = () => {
  return request("GET", "/api/auth/suite/fetch/all");
};

export const getTestCaseBySuite = (suiteId) => {
  return request("GET", `/api/auth/suite/fetch/testcase/tree/${suiteId}`);
};

export const getTestCaseSummary = (suiteId) => {
  return request("GET", `/api/auth/suite/fetch/testcase/summary/${suiteId}`);
};

export const getTestCaseDetail = (suiteId) => {
  return request("GET", `/api/auth/suite/fetch/testcase/detail/${suiteId}`);
};

export const createDefaultStandalone = (specName) => {
  return request("POST", `/api/auth/suite/create/standalone/${specName}`);
};

export const getTestSuiteByName = (specName) => {
  return request("GET", `/api/auth/suite/fetch/name/${specName}`);
};

export const getTestCaseMetaAsTree = (testType, level) => {
  const baseUrl = "/api/auth/suite/fetch/testcase/tree";
  const params = {
    testType: testType,
    level: level,
  };
  const url = `${baseUrl}?testType=${params.testType}&level=${params.level}`;
  return request("GET", url);
};

export const getTestSuiteByType = (testType) => {
  const baseUrl = "/api/auth/suite/fetch/testSuite/type";
  const params = {
    testType: testType,
  };
  const url = `${baseUrl}?testType=${params.testType}`;
  return request("GET", url);
};

export const getColumnFromSuite = (testSuiteId, testType) => {
  const baseUrl = "/api/auth/suite/fetch/testcase/columns";
  const params = {
    testSuiteId: testSuiteId,
    testType: testType,
  };
  const url = `${baseUrl}?testSuiteId=${params.testSuiteId}&testType=${testType}`;
  return request("GET", url);
};

export const getLinkedSql = (testSuiteName) => {
  return request("GET", `/api/auth/suite/fetch/linkedsql/${testSuiteName}`);
};
